// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconFaceSick = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path fillRule="evenodd" d="M12 19a7 7 0 100-14 7 7 0 000 14m0 2a9 9 0 100-18 9 9 0 000 18" />,
    <path
      fillRule="evenodd"
      d="M9.935 15.531a.224.224 0 00-.393-.04l-.71 1.064-1.664-1.11.71-1.064c.993-1.49 3.25-1.255 3.914.407.025.061.055.09.082.107.03.02.075.034.126.034a.24.24 0 00.126-.034.2.2 0 00.082-.107c.665-1.662 2.921-1.897 3.914-.407l.71 1.064-1.664 1.11-.71-1.065a.224.224 0 00-.393.041c-.746 1.864-3.384 1.864-4.13 0M11 11H8V9h3zm5 0h-3V9h3z"
    />
  );
export default SvgIconFaceSick;
